import styled, { css } from 'styled-components';

export const ContentHubDynamicCard = styled.div`
  cursor: pointer;
  background-color: #fff;
  ${({ isSelected }) =>
    isSelected
      ? css`
          border-bottom: ${({ theme }) =>
            `3px solid ${theme.color.primary800}`};
        `
      : css`
          opacity: 0.3;
          border-bottom: 3px solid #e8e8e8;
        `};
`;
